import React, { useState } from 'react';
import '../../css/incluye.scss'
import { Outlet, Link } from "react-router-dom";
import Footer from '../Footer';
import maleta from '../../assets/images/recomendacion/maleta.jpg'
import equipaje from '../../assets/images/recomendacion/equpaje.jpg'

import iconMaleta from '../../assets/images/icons/equipaje-de-viaje.png'
import iconAlimento from '../../assets/images/icons/comida.png'
import iconDesayuno from '../../assets/images/icons/desayuno.png'
import iconVegano from '../../assets/images/icons/vegano.png'
import iconAsiento from '../../assets/images/icons/asiento.png'
import iconRompecabezas from '../../assets/images/icons/rompecabezas.png'
import iconSabanas from '../../assets/images/icons/sabanas.png'



const Tab = ({ label, onClick, active, icon }) => {
    return (
      <div className={`tab_viajar ${active ? 'active' : ''}`} onClick={onClick}> 

        {icon && (
        <img
          src={icon}
          alt={label}
          className="tab-icon"
        />
      )}
        
        <p>{label}</p>
      </div>
    );
};



export default function Incluye() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

  return (
    <>
    <section className='boleto-incluye'>
        <div className='container'>
            <div className='boleto-incluye-content'>
                <div className='tabs_viajar'>
                    <div className="tab-container">
                        <div className="tab-boxes">
                        
                            <Tab
                            icon={iconMaleta}
                            label='Equipaje'
                            onClick={() => handleTabClick(0)}
                            active={activeTab === 0}                
                            />
                            <Tab
                            icon={iconAlimento}
                            label='Alimentos'
                            onClick={() => handleTabClick(1)}
                            active={activeTab === 1}
                            />
                            <Tab
                            icon={iconDesayuno}
                            label="Café con pan"
                            onClick={() => handleTabClick(9)}
                            active={activeTab === 9}
                            />
                            <Tab
                            icon={iconVegano}
                            label='Menú vegano'
                            onClick={() => handleTabClick(2)}
                            active={activeTab === 2}                
                            />
                            <Tab
                            icon={iconSabanas}
                            label='Cobija'
                            onClick={() => handleTabClick(3)}
                            active={activeTab === 3}                
                            />
                            
                            <Tab
                            icon={iconAsiento}
                            label='Asiento'
                            onClick={() => handleTabClick(4)}
                            active={activeTab === 4}            
                            />
                            <Tab
                            icon={iconRompecabezas}
                            label='Amenidades'
                            onClick={() => handleTabClick(5)}
                            active={activeTab === 5}                
                            />
                        
                        
                        </div>
                    </div>
                    <div className="content-container">
                    
                        {activeTab === 0 && 
                        <div className='info_antes_viaje'>
                            <div className="bloque-info">
                                <img src={maleta} alt="maleta" className="img-float" />

                                <h2>Equipaje documentado</h2>
                                <p>Se permite hasta 5 piezas de equipaje con las siguientes características:</p>

                                <ul>
                                    <li>Peso máximo de 25 kg</li>
                                    <li>Superficie lineal máxima de 158 cm</li>
                                </ul>

                                <p>* Si tu maleta excede el peso recomendado, Baja Ferries no podrá hacerse responsable por daños que pueda sufrir durante el manejo</p>
                                <p>* Al momento de documentar indica si necesita un trato especial, esto nos permite clasificar el equipaje.</p>

                                <p><strong>No se permite abordar</strong></p>
                                <ul>
                                    <li>Drogas</li>
                                    <li>Explosivos</li>
                                    <li>Armas blancas</li>
                                </ul>
                            </div>

                            <div className="bloque-info">
                                <img src={equipaje} alt='maleta' className="img-float"/>
                                                                 
                                <h2>Equipaje de Mano + Articulo Personal</h2>
                                <p>Maleta de mano, bolsa, mochila etc. que aborda en el barco. </p>

                                <p>Cada pasajero puede llevar:</p>
                                <ul>
                                    <li>Articulo personal.</li>
                                    <li>Equipaje de mano. <label>El equipaje de mano no deberá exceder de 55 cm x 40 cm x 25 cm para colocarse debajo de los asientos del salón y un máximo de 10 kg.</label>  </li>                       
                                </ul>
                                <label>En caso de llevar cabina solo podrás ingresar una maleta de 10 kg.</label>

                                <p>No se permite abordar</p>
                                <ul>
                                    <li>Alimentos</li>
                                    <li>Bebidas</li>
                                    <li>Almohadas</li>
                                    <li>Cobijas</li>
                                    <li>Drogas</li>
                                    <li>Explosivos</li>
                                    <li>Armas blancas</li>
                                </ul>
                            </div>
                           

                                                                   
                        </div>}
                        {activeTab === 1 && 
                        <div className='info_antes_viaje'>
                            <img src={maleta} alt='maleta' />
                            <div>
                                <h2>Alimentos de Cortesía</h2>
                                <p>Horarios de servicio abordo</p>

                                <p>Tu viaje incluye comida tipo buffet, con un platillo fuerte, botella de agua (simple o de sabor) y postre, <strong>sin costo adicional</strong>.</p>
                                
                                <p> Disfruta de este beneficio <strong>antes del zarpe</strong>. Como parte de nuestro servicio.</p>
                                <br />

                                <table className="horario-tabla">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>Lunes a viernes</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th>Ruta Pichi – Mazatlán</th>
                                            <th>Ruta Mazatlán – Pichi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="categoria">Alimentos de Cortesía</td>
                                            <td>3:30 pm a 7:30 pm</td>
                                            <td>2:00 pm a 4:30 pm</td>
                                        </tr>
                                        <tr>
                                            <td className="categoria">Café de Cortesía</td>
                                            <td>6:30 am a 7:30 am</td>
                                            <td>6:00 am a 7:00 am</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="horario-tabla">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>Lunes a viernes</th>
                                        </tr>
                                        <tr>
                                        <th></th>
                                        <th>Ruta Pichi – Mazatlán</th>
                                        <th>Ruta Mazatlán – Pichi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td className="categoria">Alimentos de Cortesía</td>
                                        <td>3:30 pm a 7:30 pm</td>
                                        <td>2:00 pm a 4:30 pm</td>
                                        </tr>
                                        <tr>
                                        <td className="categoria">Café de Cortesía</td>
                                        <td>6:30 am a 7:30 am</td>
                                        <td>6:00 am a 7:00 am</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p>Variedad de platillos:</p>
                                <ul>
                                    <li>Platillo Fuerte Pollo</li>
                                    <li>Platillo Fuerte Res</li>
                                    <li>Platillo Fuerte Puerco</li>
                                    <li>Platillo Fuerte menú Niños</li>
                                    <li>Platillo Fuerte Vegano</li>
                                    <li>Arroz</li>
                                    <li>Frijoles</li>
                                    <li>Ensalada</li>
                                    <li>Pan y tortillas</li>
                                </ul>                                
                            </div>
                            
                        </div>}
                        {activeTab === 2 && 
                        <div className='info_antes_viaje'>                           
                                <h4>text42_titulo </h4>
                                <p>text42</p>
                                <ul>
                                    <li>a) text43</li>
                                    <li>b) text44</li>
                                    <li>c) text45</li>
                                    <li>d) text46</li>
                                    <li>e) text47</li>
                                    <li>f) text48</li>
                                </ul>
                                <p>text49</p>
                            </div>}
                        {activeTab === 3 && <div className='info_antes_viaje'>
                            <h4>text50</h4>
                                <p>text51</p>
                                <p>text52</p>
                                <p><label><Link to="/aviso-de-privacidad">text53</Link>/<Link to="/condiciones-de-servicio">text54</Link></label> </p>
                                </div>}
                        {activeTab === 4 && <div className='info_antes_viaje'> <h4>text55 </h4>
                            <p><strong>text56:</strong> text57</p>
                            <p>text58</p>                                        
                            <p>text83<label><a href='https://www.banjercito.com.mx/registroVehiculos/' target="_blank" rel='noopener noreferrer' > text84</a> </label></p>

                        </div>}
                        {activeTab === 5 && 
                        <div className='info_antes_viaje'>
                            <h4>text85 </h4>
                                <p><strong>text86:</strong> text87</p>                                
                                <p><strong>text88:</strong> text89</p>                                
                                
                            
                                <p><strong>text123: </strong> text124 </p>
                                <p>text125<label  onClick={() => handleTabClick(4)} style={{color:'#0075C9', cursor: 'pointer', textDecoration: 'underline'}}>text126</label> text127</p>                                                                
                        </div>}                                                            
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer />
    </>
  )
}
